export default new (class webconfig {
  // WebApi="http://napi.zhuniangjia.com";
  // WebApi="http://api.xc1919.com";
  // WebApi="https://localhost:44380";
  // WebApi="http://tapi.520985211.com";
  // WebApi="http://adx.xtea666.com";
  //WebApi = 'http://localhost:48154';
    // WebApi = 'http://tapis.dtmyg.com';
  WebApi='https://apis.dtmyg.com';
  // WebApi = "https://apiplus.xtea666.com";
  // WebApi = "https://api.xtea666.com";
  // WebApi="https://api.xiaozhuan.shop";
  // WebApi="http://natest.zhuniangjia.com";
  // WebApi="http://ttest.zhuniangjia.com";
  // SocketApi="http://localhost:8022";
  WeixinAppId = 'wx9f771109f6eb78be';

  // 手机认证配置：enabled 是否启用手机验证，forceVerification 是否强制（false=仅提示）
  changePhoneConfig = {
    enabled: false,
    forceVerification: false,
    skipPages: ['/home', '/category', '/cart'],
    description: '手机验证配置，enabled控制是否启用功能，forceVerification控制是否强制验证'
  };
})()



// WEBPACK FOOTER //
// ./src/webconfig.config.js